import React, { useState } from "react";
import { getAuth, createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import { collection, doc, getFirestore, serverTimestamp, setDoc  } from "firebase/firestore";

export default function Signup() {
  const [displayName, setDisplayName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  // Шинээр нэмэгдсэн state: Нууц үгийг дахин баталгаажуулах
  const [confirmPassword, setConfirmPassword] = useState(""); 
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
const [name, setName] = useState("");
  const auth = getAuth();
  const db =getFirestore();

  const handleSignup = async (e) => {
    e.preventDefault();
    setError("");

    // 1. Шинэ шалгалт: Нууц үгнүүд таарч байгаа эсэхийг шалгах
    if (password !== confirmPassword) {
      setError("Нууц үгнүүд таарахгүй байна. Дахин шалгана уу.");
      return; // Хэрэв таарахгүй бол Firebase руу илгээхгүй
    }

    try {
      await createUserWithEmailAndPassword(auth, email, password); 
      await updateProfile(auth.currentUser, { 
        displayName: displayName,
      });
     const docRef = doc(db, "parkings", displayName, "users", auth.currentUser.email)

      await setDoc(docRef, {
        permissions: ["/dashboard","/settings", "/app"  ],
        role:
          "operator",
      });

console.log("Document 'cars' created successfully!");
      console.log("Document written with ID: ", docRef.id);
      setName("");
      console.log(displayName)
      setSuccess(true);
    } catch (err) {
      // Firebase-ийн алдаа (жишээ нь: weak-password, email-already-in-use)
      setError(err.message);
    }
  };

  const styles = {
    // ... (Styles are kept the same for brevity)
    container: {
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#f4f7f9", // Цайвар саарал дэвсгэр
      padding: "16px",
      fontFamily: "Arial, sans-serif",
    },
    card: {
      backgroundColor: "#ffffff",
      boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1)", // Зөөлөн сүүдэр
      borderRadius: "12px",
      padding: "32px",
      width: "100%",
      maxWidth: "380px",
    },
    header: {
      fontSize: "28px",
      fontWeight: "700",
      textAlign: "center",
      marginBottom: "24px",
      color: "#333",
    },
    input: {
      width: "100%",
      padding: "14px",
      border: "1px solid #ddd",
      borderRadius: "8px",
      marginBottom: "16px",
      boxSizing: "border-box", // Padding-ийг нийт өргөнд багтаах
      fontSize: "16px",
    },
    button: {
      width: "100%",
      backgroundColor: "#007bff", // Тод цэнхэр
      color: "white",
      padding: "14px",
      borderRadius: "8px",
      fontSize: "18px",
      fontWeight: "600",
      border: "none",
      cursor: "pointer",
      transition: "background-color 0.2s",
    },
    error: {
    textAlign:"center",
      color: "#dc3545",
      backgroundColor: "#f8d7da",
      border: "1px solid #f5c6cb",
      padding: "10px",
      borderRadius: "8px",
      marginBottom: "16px",
      fontSize: "14px",
    },
    success: {
      color: "#28a745",
      textAlign: "center",
      padding: "16px",
      backgroundColor: "#d4edda",
      border: "1px solid #c3e6cb",
      borderRadius: "8px",
      fontWeight: "600",
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.header}>Бүртгүүлэх</h2>

        {success ? (
          <p style={styles.success}>Бүртгэл амжилттай үүслээ!</p>
        ) : (
          <form onSubmit={handleSignup} style={{ display: 'flex', flexDirection: 'column' }}>
            
            <input
              type="text"
              placeholder="Байгууллагын ID"
              style={styles.input}
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
              required
            />

            <input
              type="email"
              placeholder="Имэйл хаяг"
              style={styles.input}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <input
              type="password"
              placeholder="Нууц үг"
              style={styles.input}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            
            {/* Шинээр нэмэгдсэн input */}
            <input
              type="password"
              placeholder="Нууц үгээ дахин бичнэ үү"
              style={styles.input}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />

            {error && <p style={styles.error}>⚠️ Алдаа: {error}</p>}

            <button
              style={styles.button}
              type="submit"
            >
              Бүртгэл үүсгэх
            </button>
          </form>
        )}
      </div>
    </div>
  );
}